import { CalendarDays } from "lucide-react";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";
import { EntryValueChip } from "./EntryValueChip";
import { formatEntryDate } from "./formatEntryDate";

export interface DatePickerEntryValueProps extends Omit<BaseEntryValueProps, "value"> {
    value: string | null;
}

export function DatePickerEntryValue({ value, inputLabel, size, className, ...props }: DatePickerEntryValueProps) {
    const formatted = formatEntryDate(value, "D MMM YYYY");
    return (
        <BaseEntryValue inputLabel={inputLabel} size={size} className={className} {...props}>
            <EntryValueChip icon={formatted ? CalendarDays : undefined} size={size}>
                {formatted ?? "None"}
            </EntryValueChip>
        </BaseEntryValue>
    );
}
